module.exports = __webpack_public_path__ + "img/debit.479a9226.svg";